import { useContext } from 'react';
import { IncomingPhoneNumberContext } from 'contexts/incoming_phone_number_context';

const useIncomingPhoneNumber = () => {
    return useContext(IncomingPhoneNumberContext);
};

export default useIncomingPhoneNumber;
